<template>
  <div class="tw-h-[calc(100vh-184px)] tw-flex tw-gap-4 tw-overflow-hidden">
    <!-- Sidebar: Conversation List -->
    <div class="tw-w-[340px] tw-flex-shrink-0 tw-h-full">
      <ConversationList
        @conversation-selected="onConversationSelected"
        :active-conversation-id="conversationId"
      />
    </div>

    <!-- Main: Chat Area -->
    <div class="tw-flex-1 tw-h-full tw-min-w-0">
      <!-- Empty State -->
      <div
        v-if="!conversationId"
        class="tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-white tw-border tw-border-gray-200 tw-rounded-xl tw-p-8"
      >
        <div class="tw-w-20 tw-h-20 tw-bg-gradient-to-br tw-from-primary-100 tw-to-primary-200 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-mb-5 tw-shadow-sm">
          <icon icon="solar:chat-round-dots-bold-duotone" class="tw-text-3xl tw-text-primary-600" />
        </div>
        <h3 class="tw-text-xl tw-font-semibold tw-text-gray-900 tw-mb-2">Your Messages</h3>
        <p class="tw-text-sm tw-text-gray-500 tw-text-center tw-max-w-xs tw-leading-relaxed">
          Select a conversation from the left to start chatting with users or companies.
        </p>
        <div class="tw-mt-6 tw-flex tw-items-center tw-gap-5 tw-text-xs tw-text-gray-400">
          <div class="tw-flex tw-items-center tw-gap-1.5">
            <icon icon="solar:user-bold-duotone" class="tw-text-primary-400" />
            Direct chats
          </div>
          <div class="tw-w-1 tw-h-1 tw-bg-gray-300 tw-rounded-full"></div>
          <div class="tw-flex tw-items-center tw-gap-1.5">
            <icon icon="solar:buildings-2-bold-duotone" class="tw-text-primary-400" />
            Companies
          </div>
          <div class="tw-w-1 tw-h-1 tw-bg-gray-300 tw-rounded-full"></div>
          <div class="tw-flex tw-items-center tw-gap-1.5">
            <icon icon="solar:bolt-bold-duotone" class="tw-text-primary-400" />
            Real-time
          </div>
        </div>
      </div>

      <!-- Chat View -->
      <ChatView
        v-else
        :conversationId="conversationId"
        :conversation="selectedConversation"
        :key="conversationId"
        class="tw-h-full"
      />
    </div>
  </div>
</template>

<script setup>
import ConversationList from '@/components/messages/ConversationList.vue';
import ChatView from '@/components/messages/ChatView.vue';
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const conversationId = ref(route.params.id ?? null);
const selectedConversation = ref(null);

const onConversationSelected = (conversation) => {
  selectedConversation.value = conversation;
  conversationId.value = conversation.id;
};

watch(() => route.params.id, (newId) => {
  if (newId) conversationId.value = newId;
});
</script>
